import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chatbot');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

interface NavigationTarget {
    path: string;
    title: string;
    description: string;
    auto?: boolean;
}

interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    html?: string;
    navigation?: NavigationTarget;
    timestamp: Date;
}

@Component({
    selector: 'wiz-component-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chatbot/view.scss */
@charset "UTF-8";
:host {
  display: contents;
}

/* ========================================
   FAB + Floating Chat
   ======================================== */
.chatbot-fab {
  animation: fabPulse 2s ease-in-out infinite;
  z-index: 320;
}

@keyframes fabPulse {
  0%, 100% {
    box-shadow: 0 10px 15px -3px rgba(254, 90, 51, 0.3);
  }
  50% {
    box-shadow: 0 10px 25px -3px rgba(254, 90, 51, 0.5);
  }
}
.chatbot-sidebar {
  z-index: 300;
  right: 24px;
  bottom: 96px;
  width: min(420px, 100vw - 48px);
  height: min(680px, 100vh - 120px);
}

.chatbot-panel {
  width: 100%;
  max-width: 100%;
  height: 100%;
  border-radius: 20px;
  animation: floatIn 0.24s ease-out;
}

@keyframes floatIn {
  from {
    transform: translateY(12px) scale(0.98);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.chatbot-icon-button,
.chatbot-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  line-height: 1;
}

.chatbot-icon-button i,
.chatbot-avatar i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  line-height: 1;
  font-style: normal;
}

.chatbot-icon-button i::before,
.chatbot-avatar i::before {
  display: block;
  line-height: 1;
}

.chatbot-send-button {
  padding: 0;
}

.chatbot-backdrop {
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* ========================================
   Typing Indicator
   ======================================== */
.typing-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #a1a1aa;
  animation: typingBounce 1.4s ease-in-out infinite;
}
.typing-dot:nth-child(1) {
  animation-delay: 0s;
}
.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typingBounce {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-6px);
    opacity: 1;
  }
}
/* ========================================
   Message Content Styling
   ======================================== */
.bg-zinc-100 code {
  background: rgba(0, 0, 0, 0.06);
  padding: 0.15em 0.35em;
  border-radius: 4px;
  font-size: 16px;
  font-family: "JetBrains Mono", monospace;
}
.bg-zinc-100 strong {
  font-weight: 600;
}

.chatbot-input-shell {
  border: 1px solid transparent;
}
.chatbot-input-shell:focus, .chatbot-input-shell:focus-within {
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.chatbot-input-field {
  border: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}
.chatbot-input-field:focus, .chatbot-input-field:focus-visible {
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

/* ========================================
   Responsive — Mobile
   ======================================== */
@media (max-width: 767px) {
  .chatbot-sidebar {
    inset: 0 !important;
    width: 100vw;
    height: 100vh;
    right: auto;
    bottom: auto;
  }
  .chatbot-panel {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .chatbot-sidebar {
    width: 360px;
    height: min(640px, 100vh - 112px);
  }
}
/* ========================================
   Accessibility — Reduced Motion
   ======================================== */
@media (prefers-reduced-motion: reduce) {
  .chatbot-fab {
    animation: none;
  }
  .chatbot-panel {
    animation: none;
  }
  .typing-dot {
    animation: none;
    opacity: 0.6;
  }
  .chatbot-backdrop {
    animation: none;
  }
}`],
})
export class ComponentChatbotComponent implements OnInit, OnDestroy {
    @Input() mode: string = 'auto';
    @ViewChild('chatMessages') chatMessagesEl: ElementRef;
    @ViewChild('chatInput') chatInputEl: ElementRef;

    public isOpen: boolean = false;
    public query: string = '';
    public messages: ChatMessage[] = [];
    public isLoading: boolean = false;
    public suggestionsKo: string[] = ['OEDIX가 뭔가요?', 'ReviewOps는 무엇인가요?', '솔루션 비교해주세요', '회사에 대해 알려줘'];
    public suggestionsEn: string[] = ['What is OEDIX?', 'What is ReviewOps?', 'Compare solutions', 'Tell me about SEASON'];

    private routerSub: any;
    private agentNavigationPending: boolean = false;
    private isComposing: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                if (this.agentNavigationPending) {
                    this.agentNavigationPending = false;
                    this.isOpen = true;
                } else {
                    this.isOpen = false;
                }
                await this.service.render();
                this.scrollToBottom();
            }
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    get suggestions() {
        return this.service.lang.is('ko') ? this.suggestionsKo : this.suggestionsEn;
    }

    public async toggle() {
        this.isOpen = !this.isOpen;
        await this.service.render();
        if (this.isOpen) this.focusInput();
    }

    public async close() {
        this.isOpen = false;
        await this.service.render();
    }

    public async sendChip(chip: string) {
        this.query = chip;
        await this.send();
    }

    public async send() {
        const q = this.query.trim();
        if (!q || this.isLoading) return;

        this.messages.push({
            role: 'user',
            content: q,
            timestamp: new Date()
        });
        this.query = '';
        this.clearInputValue();
        this.isLoading = true;
        this.isOpen = true;
        await this.renderSafely();
        this.clearInputValue();
        this.scrollToBottom();

        try {
            const res = await this.callChatbotApi(q, 'initial');
            const data = this.responseData(res);
            if (!data) {
                this.pushAssistantError();
            } else if (this.shouldFetchAfterNavigation(data)) {
                const navigationPath = String(data.navigation.path);
                await this.navigateToSafely(navigationPath, true);
                await this.waitForRoute(navigationPath);
                await this.waitForScreenContent();
                const followup = await this.callChatbotApi(q, 'after_navigation');
                const followupData = this.responseData(followup);
                if (followupData) {
                    const fallbackNavigation = followupData.navigation?.path ? '' : navigationPath;
                    this.pushAssistantMessage(followupData, fallbackNavigation);
                } else {
                    this.pushAssistantError();
                }
            } else {
                const autoNavigationPath = this.pushAssistantMessage(data);
                if (autoNavigationPath && !this.isCurrentPath(autoNavigationPath)) {
                    await this.navigateToSafely(autoNavigationPath, true);
                }
            }
        } catch (e) {
            const fallback = this.clientFallbackMessage(q);
            this.messages.push({
                role: 'assistant',
                content: fallback,
                html: this.renderMarkdown(fallback),
                timestamp: new Date()
            });
        }

        this.isLoading = false;
        await this.renderSafely();
        this.scrollToBottom();
    }

    public async navigateTo(path: string, keepOpen: boolean = false) {
        if (!path) return;
        if (this.isCurrentPath(path)) {
            this.isOpen = true;
            await this.renderSafely();
            this.scrollToBottom();
            return;
        }
        this.agentNavigationPending = keepOpen;
        this.isOpen = keepOpen;
        try {
            this.service.href(path);
        } catch (e) {
            this.agentNavigationPending = false;
        }
        if (!keepOpen) await this.renderSafely();
    }

    public onKeydownEscape() {
        this.close();
    }

    public onCompositionStart() {
        this.isComposing = true;
    }

    public onCompositionEnd(event?: any) {
        this.isComposing = false;
        if (this.isLoading) {
            this.query = '';
            this.clearInputValue();
            return;
        }
        if (event?.target?.value !== undefined) {
            this.query = event.target.value;
        }
    }

    public async onInputEnter(event: KeyboardEvent) {
        if (event.isComposing || this.isComposing || (event as any).keyCode === 229) return;
        event.preventDefault();
        await this.send();
    }

    private scrollToBottom() {
        setTimeout(() => {
            if (this.chatMessagesEl?.nativeElement) {
                const el = this.chatMessagesEl.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 50);
    }

    private focusInput() {
        setTimeout(() => {
            if (this.chatInputEl?.nativeElement) {
                this.chatInputEl.nativeElement.focus();
            }
        }, 80);
    }

    private clearInputValue() {
        const reset = () => {
            if (this.chatInputEl?.nativeElement) {
                this.chatInputEl.nativeElement.value = '';
            }
        };
        reset();
        setTimeout(reset, 0);
    }

    private renderMarkdown(text: string): string {
        if (!text) return '';
        const escaped = this.escapeHtml(text);
        let html = escaped
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            .replace(/`(.*?)`/g, '<code>$1</code>')
            .replace(/\n/g, '<br>');
        return html;
    }

    private async navigateToSafely(path: string, keepOpen: boolean = false) {
        try {
            await this.navigateTo(path, keepOpen);
        } catch (e) {
            this.agentNavigationPending = false;
        }
    }

    private async renderSafely() {
        try {
            await this.service.render();
        } catch (e) {
        }
    }

    private messageText(value: any): string {
        if (value === undefined || value === null) return '';
        if (typeof value === 'string') return value;
        try {
            return JSON.stringify(value);
        } catch (e) {
            return String(value);
        }
    }

    private responseData(response: any): any {
        if (response?.code !== 200) return null;
        return response.data?.data || response.data || null;
    }

    private shouldFetchAfterNavigation(data: any): boolean {
        const path = data?.navigation?.path ? String(data.navigation.path) : '';
        return !!data?.needsScreenContext && !!path && data.navigation.auto !== false && !this.isCurrentPath(path);
    }

    private pushAssistantMessage(data: any, fallbackNavigationPath: string = ''): string {
        const answer = this.messageText(data.message);
        if (answer) {
            const msg: ChatMessage = {
                role: 'assistant',
                content: answer,
                html: this.renderMarkdown(answer),
                timestamp: new Date()
            };
            if (data.navigation?.path) msg.navigation = data.navigation;
            this.messages.push(msg);
        }

        const path = data.navigation?.path ? String(data.navigation.path) : fallbackNavigationPath;
        if (path && data.navigation?.auto !== false) return path;
        return '';
    }

    private pushAssistantError() {
        const fallback = this.service.lang.is('ko') ? 'AI 응답 서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.' : 'The AI response server is currently unavailable. Please try again later.';
        this.messages.push({
            role: 'assistant',
            content: fallback,
            html: this.renderMarkdown(fallback),
            timestamp: new Date()
        });
    }

    private async callChatbotApi(query: string, contextMode: string = 'initial'): Promise<any> {
        const body = new URLSearchParams();
        body.set('query', query);
        body.set('current_path', this.router.url || '/main');
        body.set('locale', this.service.lang.get() || 'ko');
        body.set('context_mode', contextMode);
        body.set('history', JSON.stringify(this.recentHistory()));
        body.set('screen_context', this.currentScreenContext());

        const response = await fetch('/wiz/api/page.main/chatbot_query', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: body.toString(),
            credentials: 'same-origin'
        });
        if (!response.ok) throw new Error(`Chatbot API failed with ${response.status}`);
        return await response.json();
    }

    private async waitForRoute(path: string, timeout: number = 2500) {
        const started = Date.now();
        while (!this.isCurrentPath(path) && Date.now() - started < timeout) {
            await this.wait(80);
        }
    }

    private async waitForScreenContent(timeout: number = 2500) {
        const started = Date.now();
        let previous = '';
        while (Date.now() - started < timeout) {
            await this.wait(120);
            const text = this.currentScreenContext();
            if (text.length > 120 && text === previous) return;
            previous = text;
        }
    }

    private wait(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private clientFallbackMessage(_query: string): string {
        if (this.service.lang.is('ko')) {
            return 'AI 응답 서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.';
        }
        return 'The AI response server is currently unavailable. Please try again later.';
    }

    private recentHistory(): Array<{ role: 'user' | 'assistant'; content: string }> {
        return this.messages
            .slice(-8)
            .map((message: ChatMessage) => ({
                role: message.role,
                content: message.content
            }))
            .filter((message) => !!message.content);
    }

    private currentScreenContext(): string {
        try {
            const root = document.querySelector('main') || document.querySelector('[class*="page-"]') || document.body;
            if (!root) return '';
            const clone = root.cloneNode(true) as HTMLElement;
            clone.querySelectorAll('script, style, wiz-component-chatbot, .chatbot, nav, footer').forEach((node) => node.remove());
            const title = document.title || '';
            const text = `${title}\n${clone.textContent || ''}`.replace(/\s+/g, ' ').trim();
            return text.substring(0, 6000);
        } catch (e) {
            return '';
        }
    }

    private isCurrentPath(path: string): boolean {
        return this.normalizePath(path) === this.normalizePath(this.router.url);
    }

    private normalizePath(path: string): string {
        let value = (path || '/main').split('?')[0].split('#')[0].replace(/\/+$/, '');
        if (!value) value = '/main';
        if (value === '/') value = '/main';
        return value;
    }

    private escapeHtml(text: string): string {
        return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
}

export default ComponentChatbotComponent;